module.exports = __webpack_public_path__ + "assets/img/674d6435aa2cc63f211b0b38c6a120f1.png";